<div class="left-modal">
  <div class="close" (click)="close()"></div>
  <div class="modal-container">
    <h1>{{'Filter scenes' | translate}}</h1>
    <form #form="ngForm" (ngSubmit)="filter()" novalidate>
      <div class="row">
        <div class="L-3 M-3 S-6 columns">
          <label>{{'Chapter from' | translate}}</label>
          <input class="centered" type="text" name="chapter_from" [(ngModel)]="viewFilterArguments.chapter_from" placeholder="{{'Insert number' | translate}}" [pattern]="_gS.regex.number">
        </div>
        <div class="L-3 M-3 S-6 columns">
          <label>{{'Chapter to' | translate}}</label>
          <input class="centered" type="text" name="chapter_to" [(ngModel)]="viewFilterArguments.chapter_to" placeholder="{{'Insert number' | translate}}" [pattern]="_gS.regex.number">
        </div>
        <div class="L-3 M-3 S-6 columns">
          <label>{{'Day history from' | translate}}</label>
          <input class="centered" type="text" name="day_history_from" [(ngModel)]="viewFilterArguments.day_history_from" placeholder="{{'Insert number' | translate}}" [pattern]="_gS.regex.number">
        </div>
        <div class="L-3 M-3 S-6 columns">
          <label>{{'Day history to' | translate}}</label>
          <input class="centered" type="text" name="day_history_to" [(ngModel)]="viewFilterArguments.day_history_to" placeholder="{{'Insert number' | translate}}" [pattern]="_gS.regex.number">
        </div>
        <div class="L-4 M-4 S-6 columns">
          <label>{{'Location / studio' | translate}}**</label>
          <app-dropdown
            [(appModel)]="viewFilterArguments.location_studio_option_id"
            [list]="viewData.scene_loc_std_options"
            [value]="'id'"
            [name]="'name'"
            [backTranslate]="true"
            [showEmpty]="true"
            [placeholder]="'View both' | translate"
          ></app-dropdown>
        </div>
        <div class="L-4 M-4 S-6 columns">
          <label>{{'Scene type' | translate}}</label>
          <app-dropdown
            [(appModel)]="viewFilterArguments.scene_types"
            [list]="viewData.scene_types"
            [value]="'id'"
            [name]="'name'"
            [multiple]="true"
            [backTranslate]="true"
          ></app-dropdown>
        </div>
        <div class="L-4 M-4 S-6 columns">
          <label>{{'Interior / exterior' | translate}}**</label>
          <app-dropdown
            [(appModel)]="viewFilterArguments.interior_exterior_option_id"
            [list]="viewData.scene_interior_exterior_options"
            [value]="'id'"
            [name]="'name'"
            [backTranslate]="true"
            [showEmpty]="true"
            [placeholder]="'View both' | translate"
          ></app-dropdown>
        </div>
        <div class="L-4 M-4 S-6 columns">
          <label>{{'Day / night' | translate}}**</label>
          <app-dropdown
            [(appModel)]="viewFilterArguments.day_night_option_id"
            [list]="viewData.scene_day_night_options"
            [value]="'id'"
            [name]="'name'"
            [backTranslate]="true"
            [showEmpty]="true"
            [placeholder]="'View both' | translate"
          ></app-dropdown>
        </div>
        @if (viewData.locations?.length > 0) {
          <div class="L-12 M-12 S-12 columns">
            <label>{{'Location' | translate}}</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.locations"
              (appModelChange)="filterSets()"
              [list]="viewData.locations"
              [value]="'id'"
              [name]="'location_name'"
              [multiple]="true"
            ></app-dropdown>
          </div>
        }
        @if (viewData.characters?.length > 0) {
          <div class="L-12 M-12 S-12 columns">
            <label>{{'Character' | translate}}</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.characters"
              (appModelChange)="filterSets()"
              [list]="viewData.characters"
              [value]="'id'"
              [name]="'character_name'"
              [multiple]="true"
            ></app-dropdown>
          </div>
        }
        @if (viewData.sets?.length > 0 && isLocation) {
          <div class="L-12 M-12 S-12 columns">
            <label>{{'Set' | translate}}</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.sets"
              [list]="viewData.sets"
              [value]="'id'"
              [name]="'set_name'"
              [multiple]="true"
            ></app-dropdown>
          </div>
        }
        @if (!isLocation) {
          <div class="L-12 M-12 S-12 columns">
            <label>{{'Set' | translate}}</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.sets"
              [list]="filteredSets"
              [value]="'id'"
              [name]="'set_name'"
              [multiple]="true"
            ></app-dropdown>
          </div>
        }
      </div>
      <div class="L-12 M-12 S-12 columns TextCentered">
        <input name="sumbit" type="submit" value="{{'Filter' | translate}}" [attr.disabled]="form.invalid?'':null">
      </div>
      <div class="L-12 M-12 S-12 columns TextCentered">
        <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
      </div>
    </form>
  </div>
</div>
